<kendo-tabstrip (tabSelect)="onTabSelect($event)">
  <kendo-tabstrip-tab title="Categories" [selected]="true">
    <ng-template kendoTabContent>
      <kendo-grid [data]="categoryGridView"
                  [height]="470"
                  [sortable]="true"
                  [navigable]="true"
                  [filterable]="true"
                  [groupable]="false"
                  [reorderable]="true"
                  [resizable]="false"
                  [sort]="categoryGridstate.sort"
                  (sortChange)="categoryGridSortChange($event)"
                  [pageable]="{ buttonCount: 5, info: true }"
                  [pageSize]="categoryGridstate.take"
                  [skip]="categoryGridstate.skip"
                  [columnMenu]="false"
                  (pageChange)="categoryGridPageChange($event)"
                  (dataStateChange)="categoryDataStateChange($event)"
                  [filter]="categoryGridstate.filter"
                  [loading]="categoryLoading">
        <kendo-grid-column field="languageCode" title="Language" [columnMenu]="false"
                           [filterable]="true" [editable]="false">
        </kendo-grid-column>
        <kendo-grid-column field="imageUrl" title="{{categoryLbl.image}}" [columnMenu]="false"
                           [filterable]="false" [editable]="false">
          <ng-template kendoGridCellTemplate let-dataItem>
            <img src="{{dataItem.imageUrl}}" style="height:100px;width:150px;" />
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="name" title="{{categoryLbl.name}}" [columnMenu]="false"
                           [filterable]="true" [editable]="false">
        </kendo-grid-column>
        <kendo-grid-column field="description" title="{{categoryLbl.description}}" [columnMenu]="false"
                           [filterable]="true" [editable]="false">
          <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="isActive"
                           title="{{categoryLbl.isActive}}"
                           [filterable]="false"
                           [columnMenu]="false">
          <ng-template kendoGridCellTemplate let-dataItem>
            <kendo-switch (click)="switchChange(dataItem)"
                          [(ngModel)]="dataItem.isActive"
                          [onLabel]="'Yes'"
                          [offLabel]="'No'"
                          [disabled]="true">
            </kendo-switch>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-command-column title="{{categoryLbl.action}}" [width]="150" field="">
          <ng-template kendoGridCellTemplate let-dataItem>
            <button kendoButton class="m-2 clearKendoButton btn btn-success btnSizeCls"
                    (click)="initEditCategoryModal(dataItem)">
              <span class=" k-icon k-i-edit k-i-pencil"></span>
            </button>
            <button class="k-button k-grid-remove-command " (click)="removeConfirmation(dataItem, 'Category')">
              <span class="k-icon k-i-trash">
              </span>
            </button>
            <br>

          </ng-template>
        </kendo-grid-command-column>

        <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
          <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
          <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
          <kendo-pager-info></kendo-pager-info>
          <kendo-pager-next-buttons></kendo-pager-next-buttons>
          <kendo-pager-page-sizes [pageSizes]="[50,75,100]"></kendo-pager-page-sizes>
        </ng-template>
      </kendo-grid>
      <div class="col-sm-12 center">
        <button (click)="initAddProductCategoryModal()" [icon]="'plus'" class="m-3 btn btn-success" kendoButton>
          Add Product Category
        </button>
      </div>

      <section class="dialogSection">
        <kendo-dialog title="{{productCategoryDialog?.title}}" *ngIf="productCategoryDialog?.opened" (close)="productCategoryDialog.opened=false">
          <form style="max-height: 400px">
            <div class="row">
              <div class="col-sm-12 zeroRightPadding">
                <div class="form-group">
                  <label class="lblCls">
                    Language<span class="requiredField">*</span>
                  </label>
                  <kendo-dropdownlist class="kendoInput" name="languageCode"
                                      [data]="getLanguages"
                                      [(ngModel)]="categoryModel.languageCode"
                                      [textField]="'languageCode'"
                                      [valueField]="'languageCode'"
                                      [valuePrimitive]="true"
                                      (selectionChange)="languageChange($event)"
                                      [ngClass]="{'borderRed':productCategoryDialog.isEmptyLanguage && shouldShowCatModalError}"
                                      (blur)="validateProductCategoryForm()">
                  </kendo-dropdownlist>
                </div>

                <div class="form-group">
                  <label class="lblCls">
                    {{productCategoryDialog?.nameLbl}}<span class="requiredField">*</span>
                  </label>
                  <input type="text" kendoTextBox class="kendoInput" name="name" [(ngModel)]="categoryModel.name"
                         [ngClass]="{'borderRed':productCategoryDialog?.isEmptyName && shouldShowCatModalError}"
                         (blur)="validateProductCategoryForm()" />
                </div>
                <div class="form-group">
                  <label class="lblCls">
                    {{productCategoryDialog?.descriptionLbl}}<span class="requiredField">*</span>
                  </label>
                  <input type="text" kendoTextBox class="kendoInput" name="description"
                         [(ngModel)]="categoryModel.description"
                         [ngClass]="{'borderRed':productCategoryDialog?.isEmptyDescription && shouldShowCatModalError}"
                         (blur)="validateProductCategoryForm()" />
                </div>
                <div class="form-group">
                  <label class="lblCls">
                    {{productCategoryDialog?.imageUrlLbl}}<!--<span class="requiredField">*</span>-->
                  </label>
                  <!--<input type="file" class="k-button btn kendoInput" name="imageUrl" [(ngModel)]="categoryModel.imageUrl"
    (change)="handleFileInputproductCategory($event.target.files)" />-->
                  <app-upload [multiple]="false" (fileSelect)="categoryImageSelected($event)" [uploadFolderPath]="'TempDocs\\ProductImages'"
                              (uploadSuccess)="categoryImageUploadSuccess($event)" [fileRestrictions]="fileRestrictions"></app-upload>
                </div>
                <div class="form-group">
                  <img [src]="imageCategorySrc" *ngIf="imageCategorySrc" style="height: 120px; width:300px">
                  <!--<label class="lblCls">
      {{imageCategorySrc}}
    </label>-->
                </div>
                <div class="form-group">
                  <label class="lblCls">
                    {{productCategoryDialog?.isActiveLbl}}
                  </label>
                  <kendo-switch name="isActive" [(ngModel)]="categoryModel.isActive" [onLabel]="'Yes'" [offLabel]="'No'"
                                class="activeSwitchCls">
                  </kendo-switch>
                </div>
              </div>
            </div>
            <div class="dialog-btn-section">
              <div class="row">
                <div class="col-sm-12 float-left">
                  <app-info *ngIf="infoMessage" [infoMessage]="infoMessage"></app-info>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 btn-align-center">
                  <div class="btn-group" role="group">
                    <button kendoButton [disabled]="productCategoryDialog?.saveInProcess" class=" m-3 btn k-button dialogBtnSize"
                            (click)="productCategoryDialog.opened=false;resetProductCategory()">
                      Close
                    </button> &nbsp;&nbsp;
                    <button kendoButton [disabled]="productCategoryDialog?.saveInProcess" class=" m-3 btn btn-success dialogBtnSize"
                            (click)="saveProductCategory()">
                      Save<kendo-loader *ngIf="productCategoryDialog?.saveInProcess" style="color:blue"></kendo-loader>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </kendo-dialog>
      </section>
    </ng-template>
  </kendo-tabstrip-tab>
  <kendo-tabstrip-tab title="Subcategories">
    <ng-template kendoTabContent>
      <kendo-grid [data]="subCategoryGridView"
                  [height]="470"
                  [sortable]="true"
                  [navigable]="true"
                  [filterable]="true"
                  [groupable]="false"
                  [reorderable]="true"
                  [resizable]="false"
                  [sort]="subCategoryGridstate.sort"
                  (sortChange)="subCategoryGridSortChange($event)"
                  [pageable]="{ buttonCount: 5, info: true }"
                  [pageSize]="subCategoryGridstate.take"
                  [skip]="subCategoryGridstate.skip"
                  [columnMenu]="false"
                  (pageChange)="subCategoryGridPageChange($event)"
                  (dataStateChange)="subCategoryDataStateChange($event)"
                  [filter]="subCategoryGridstate.filter"
                  [loading]="subCategoryLoading">

        <kendo-grid-column field="languageCode" title="Language" [columnMenu]="false"
                           [filterable]="true" [editable]="false">
        </kendo-grid-column>
        <kendo-grid-column field="productCategoryImageUrl" title="{{subCategoryLbl.categoryImage}}" [columnMenu]="false"
                           [filterable]="false" [editable]="false">
          <ng-template kendoGridCellTemplate let-dataItem>
            <img src="{{dataItem.productCategoryImageUrl}}" style="height:100px;width:150px;" />
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="productCategoryName" title="{{subCategoryLbl.categoryName}}" [columnMenu]="false"
                           [filterable]="true" [editable]="false">
          <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="productImageUrl" title="{{subCategoryLbl.subCategoryImage}}" [columnMenu]="false"
                           [filterable]="false" [editable]="false">
          <ng-template kendoGridCellTemplate let-dataItem>

            <img src="{{dataItem.productImageUrl}}" style="height:100px;width:150px;" />

          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="name" title="{{subCategoryLbl.subcategoryName}}" [columnMenu]="false"
                           [filterable]="true" [editable]="false">
          <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-command-column title="{{subCategoryLbl.isActive}}" [width]="135" field="isActive">
          <ng-template kendoGridCellTemplate let-dataItem>
            <kendo-switch (click)="switchChange(dataItem)"
                          [(ngModel)]="dataItem.isActive"
                          [onLabel]="'Yes'"
                          [offLabel]="'No'"
                          [disabled]="true">
            </kendo-switch>
          </ng-template>
        </kendo-grid-command-column>

        <kendo-grid-command-column title="{{productMappingLbl.action}}" [width]="150" field="">
          <ng-template kendoGridCellTemplate let-dataItem>
            <button kendoButton class="m-2 clearKendoButton btn btn-success btnSizeCls"
                    (click)="editProductSubCategory(dataItem)">
              <span class=" k-icon k-i-edit k-i-pencil"></span>
            </button>
            <button class="k-button k-grid-remove-command " (click)="removeConfirmation(dataItem, 'SubCategory')">
              <span class="k-icon k-i-trash">
              </span>
            </button>
            <br>

          </ng-template>
        </kendo-grid-command-column>

        <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
          <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
          <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
          <kendo-pager-info></kendo-pager-info>
          <kendo-pager-next-buttons></kendo-pager-next-buttons>
          <kendo-pager-page-sizes [pageSizes]="[50,75,100]"></kendo-pager-page-sizes>
        </ng-template>
      </kendo-grid>
      <div class="col-sm-12 center">
        <button (click)="addProductSubCategory()" [icon]="'plus'" class="m-3 btn btn-success" kendoButton>
          Add Product SubCategory
        </button>
      </div>

      <section class="dialogSection">
        <kendo-dialog title="{{productSubCategoryDialog?.title}}" *ngIf="productSubCategoryDialog?.opened" (close)="productSubCategoryDialog.opened=false;">
          <form style="max-height: 600px">
            <div class="row">
              <div class="col-sm-12 zeroRightPadding">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="lblCls">
                        Language<span class="requiredField">*</span>
                      </label>
                      <kendo-dropdownlist class="kendoInput" name="languageCode"
                                          [data]="getLanguages"
                                          [(ngModel)]="subCategoryModel.languageCode"
                                          [textField]="'languageCode'"
                                          [valueField]="'languageCode'"
                                          [valuePrimitive]="true"
                                          (selectionChange)="subCategoryLanguageChange($event)"
                                          [ngClass]="{'borderRed':productSubCategoryDialog.isEmptyLanguage && shouldShowSubCatModalError}"
                                          (blur)="validateProductSubCategoryForm()">
                      </kendo-dropdownlist>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="lblCls">
                        {{productSubCategoryDialog?.countryCodelbl}}
                      </label>
                      <kendo-dropdownlist class="kendoInput" name="countryCode"
                                          [data]="getCountrys"
                                          [(ngModel)]="subCategoryModel.countryCode"
                                          [textField]="'countryCode'"
                                          [valueField]="'countryCode'"
                                          [valuePrimitive]="true"
                                          (selectionChange)="countryChange($event)">
                      </kendo-dropdownlist>
                    </div>
                  </div>
                  </div>
                  <div class="form-group">
                    <label class="lblCls">
                      {{productSubCategoryDialog?.categoryLbl}}<span class="requiredField">*</span>
                    </label>
                    <kendo-dropdownlist class="kendoInput" name="productCategory"
                                        [(ngModel)]="catForSubCatEditModal" [data]="productCategoryDropData"
                                        textField="name" valueField="id"
                                        (selectionChange)="productSubCategoryProductCategorySelectionChange($event)"
                                        [ngClass]="{'borderRed':productSubCategoryDialog?.isEmptyProductCategory && shouldShowSubCatModalError}"
                                        (blur)="validateProductSubCategoryForm()">
                    </kendo-dropdownlist>
                  </div>
               
                  <div class="form-group">
                    <label class="lblCls">
                      {{productSubCategoryDialog?.nameLbl}}<span class="requiredField">*</span>
                    </label>
                    <input type="text" kendoTextBox class="kendoInput" name="name" [(ngModel)]="subCategoryModel.name"
                           [ngClass]="{'borderRed':productSubCategoryDialog?.isEmptyName && shouldShowSubCatModalError}"
                           (blur)="validateProductSubCategoryForm()" />
                  </div>
                  <div class="form-group">
                    <label class="lblCls">
                      {{productSubCategoryDialog?.descriptionLbl}}<span class="requiredField">*</span>
                    </label>
                    <!--[(ngModel)]="subCategoryModel.description"-->
                    <section *ngFor="let des of subCategoryDescription; index as i; first as isFirst; last as isLast">
                      <input type="text" kendoTextBox class="kendoInput" name="description_{{des.id}}"
                             [ngClass]="{'borderRed':productSubCategoryDialog?.isEmptyDescription && shouldShowSubCatModalError}"
                             [(ngModel)]="des.description"
                             (blur)="validateProductSubCategoryForm()" />
                      <span class="k-icon k-i-plus" style="color: green;" *ngIf="isLast" (click)="addSubCategoryDescription()"
                            title="Add New"></span>
                      <span class="k-icon k-i-minus" style="color: red;" *ngIf="i!=0" (click)="removeSubCategoryDescription(i)"
                            title="Delete"></span>
                    </section>
                  </div>
                  <div class="form-group">
                    <label class="lblCls">
                      {{productSubCategoryDialog?.imageUrlLbl}}<!--<span class="requiredField">*</span>-->
                    </label>
                    <app-upload [multiple]="false" (fileSelect)="subCategoryImageSelected($event)" [uploadFolderPath]="'TempDocs\\ProductImages'"
                                (uploadSuccess)="subCategoryImageUploadSuccess($event)" [fileRestrictions]="fileRestrictions"></app-upload>
                  </div>
                  <div class="form-group">
                    <img [src]="imageSubCategorySrc" *ngIf="imageSubCategorySrc" style="height: 120px; width:300px">
                    <!--<label class="lblCls">
      {{imageSubCategorySrc}}
    </label>-->
                  </div>
                  <div class="form-group">
                    <label class="lblCls">
                      {{productSubCategoryDialog?.isActiveLbl}}
                    </label>
                    <kendo-switch name="isActive" [(ngModel)]="subCategoryModel.isActive" [onLabel]="'Yes'" [offLabel]="'No'"
                                  class="activeSwitchCls">
                    </kendo-switch>
                  </div>
                </div>

            </div>

            <div class="dialog-btn-section">
              <div class="row">
                <div class="col-sm-12 float-left">
                  <app-info *ngIf="infoMessage" [infoMessage]="infoMessage"></app-info>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 btn-align-center">
                  <div class="btn-group" role="group">
                    <button kendoButton [disabled]="productSubCategoryDialog?.saveInProcess" class=" m-3 btn k-button dialogBtnSize"
                            (click)="productSubCategoryDialog.opened=false;resetsubCategoryModel()">
                      Close
                    </button> &nbsp;&nbsp;
                    <button kendoButton [disabled]="productSubCategoryDialog?.saveInProcess" class=" m-3 btn btn-success dialogBtnSize"
                            (click)="saveSubProductCategory()">
                      Save<kendo-loader *ngIf="productSubCategoryDialog?.saveInProcess" style="color:blue"></kendo-loader>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </kendo-dialog>
      </section>
    </ng-template>
  </kendo-tabstrip-tab>
  <kendo-tabstrip-tab title="Configuration">
    <ng-template kendoTabContent>
      <kendo-grid [data]="configurationGridView"
                  [height]="470"
                  [sortable]="true"
                  [navigable]="true"
                  [filterable]="true"
                  [groupable]="false"
                  [reorderable]="true"
                  [resizable]="true"
                  [sort]="configurationGridstate.sort"
                  (sortChange)="configurationGridSortChange($event)"
                  [pageable]="{ buttonCount: 5, info: true }"
                  [pageSize]="configurationGridstate.take"
                  [skip]="configurationGridstate.skip"
                  [columnMenu]="false"
                  (pageChange)="configurationGridPageChange($event)"
                  (dataStateChange)="configurationDataStateChange($event)"
                  [filter]="configurationGridstate.filter"
                  [loading]="configurationLoading">
        <kendo-grid-column field="languageCode" title="Language" [columnMenu]="false"
                           [filterable]="true" [editable]="false">
        </kendo-grid-column>
        <kendo-grid-column field="catImageUrl" title="{{productMappingLbl.categoryImage}}" [columnMenu]="false"
                           [filterable]="false" [editable]="false">
          <ng-template kendoGridCellTemplate let-dataItem>

            <img src="{{dataItem.catImageUrl}}" style="height:100px;width:150px;" />

          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="catName" title="{{productMappingLbl.categoryName}}" [columnMenu]="false"
                           [filterable]="true" [editable]="false">
          <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="subCatImageUrl" title="{{productMappingLbl.subCategoryImage}}" [columnMenu]="false"
                           [filterable]="false" [editable]="false">
          <ng-template kendoGridCellTemplate let-dataItem>

            <img src="{{dataItem.subCatImageUrl}}" style="height:100px;width:150px;" />

          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="subCatName" title="{{productMappingLbl.subCategoryName}}" [columnMenu]="false"
                           [filterable]="true" [editable]="false">
          <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="productImageUrl" title="{{productMappingLbl.configImage}}" [columnMenu]="false"
                           [filterable]="false" [editable]="false">
          <ng-template kendoGridCellTemplate let-dataItem>

            <img src="{{dataItem.imageUrl}}" style="height:100px;width:150px;" />

          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="name"
                           title="{{productMappingLbl.configName}}" [columnMenu]="false"
                           [filterable]="true" [editable]="false">
          <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-command-column title="{{productMappingLbl.isActive}}" [width]="135" field="isActive">
          <ng-template kendoGridCellTemplate let-dataItem>
            <kendo-switch (click)="switchChange(dataItem)" [(ngModel)]="dataItem.isActive"
                          [disabled]="true"
                          [onLabel]="'Yes'"
                          [offLabel]="'No'">
            </kendo-switch>
          </ng-template>
        </kendo-grid-command-column>
        <kendo-grid-column field="productTemplateName" title="{{productMappingLbl.templateName}}" [columnMenu]="false"
                           [filterable]="true" [editable]="false">
          <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="productCode" title="{{productMappingLbl.templateCode}}" [columnMenu]="false"
                           [filterable]="true" [editable]="false">
          <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-command-column title="{{productMappingLbl.action}}" [width]="150" field="">
          <ng-template kendoGridCellTemplate let-dataItem>
            <button kendoButton class="m-2 clearKendoButton btn btn-success btnSizeCls"
                    (click)="editproductConfiguration(dataItem)">
              <span class=" k-icon k-i-edit k-i-pencil"></span>
            </button>
            <button class="k-button k-grid-remove-command " (click)="removeConfirmation(dataItem, 'Config')">
              <span class="k-icon k-i-trash">
              </span>
            </button>
            <br>

          </ng-template>
        </kendo-grid-command-column>

        <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
          <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
          <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
          <kendo-pager-info></kendo-pager-info>
          <kendo-pager-next-buttons></kendo-pager-next-buttons>
          <kendo-pager-page-sizes [pageSizes]="[50,75,100]"></kendo-pager-page-sizes>
        </ng-template>
      </kendo-grid>
      <div class="col-sm-12 center">
        <button (click)="addProductConfiguration()" [icon]="'plus'" class="m-3 btn btn-success" kendoButton>
          Add Product Configuration
        </button>
      </div>

      <section class="dialogSection">
        <kendo-dialog title="{{productConfigurationDialog?.title}}" *ngIf="productConfigurationDialog?.opened" (close)="productConfigurationDialog.opened=false">
          <form style="max-height: 600px" autocomplete="off">
            <div class="row">
              <div class="col-sm-12 zeroRightPadding">
                <div class="form-group">
                  <label class="lblCls">
                    Language<span class="requiredField">*</span>
                  </label>
                  <kendo-dropdownlist class="kendoInput" name="languageCode"
                                      [data]="getLanguages"
                                      [(ngModel)]="configModal_1.languageCode"
                                      [textField]="'languageCode'"
                                      [valueField]="'languageCode'"
                                      [valuePrimitive]="true"
                                      (selectionChange)="configModalLanguageChange($event)"
                                      [ngClass]="{'borderRed':productConfigurationDialog?.isEmptyLanguage && shouldShowConfigModalError}"
                                      (blur)="validateProductConfigurationForm()">
                  </kendo-dropdownlist>
                </div>
                <div class="form-group">
                  <label class="lblCls">
                    {{productConfigurationDialog?.productCategoryLbl}}<span class="requiredField">*</span>
                  </label>
                  <kendo-dropdownlist class="kendoInput" name="productCategory"
                                      [(ngModel)]="configModal_1.selectedCat"
                                      [data]="configModal_1.catList"
                                      textField="name" valueField="uniqueId"
                                      (selectionChange)="configModalCategoryChange($event)"
                                      [ngClass]="{'borderRed':productConfigurationDialog?.isEmptyProductCategory && shouldShowConfigModalError}"
                                      (blur)="validateProductConfigurationForm()">
                  </kendo-dropdownlist>
                </div>
                <div class="form-group">
                  <label class="lblCls">
                    {{productConfigurationDialog?.productSubCategoryLbl}}<span class="requiredField">*</span>
                  </label>
                  <kendo-dropdownlist class="kendoInput"
                                      name="productSubCategory"
                                      [data]="configModal_1.subCatList"
                                      textField="name" valueField="id"
                                      [(ngModel)]="configModal_1.selectedSubCat"
                                      [ngClass]="{'borderRed':productConfigurationDialog?.isEmptyProductSubCategory && shouldShowConfigModalError}"
                                      (blur)="validateProductConfigurationForm()">
                  </kendo-dropdownlist>
                </div>
                <div class="form-group">
                  <label class="lblCls">
                    {{productConfigurationDialog?.nameLbl}}<span class="requiredField">*</span>
                  </label>
                  <input type="text" kendoTextBox class="kendoInput" name="name"
                         [(ngModel)]="configModal_1.name"
                         [ngClass]="{'borderRed':productConfigurationDialog?.isEmptyName && shouldShowConfigModalError}"
                         (blur)="validateProductConfigurationForm()" />
                </div>
                <div class="form-group">
                  <label class="lblCls">
                    {{productConfigurationDialog?.descriptionLbl}}<span class="requiredField">*</span>
                  </label>
                  <input type="text" kendoTextBox class="kendoInput" name="description"
                         [(ngModel)]="configModal_1.description"
                         [ngClass]="{'borderRed':productConfigurationDialog?.isEmptyDescription && shouldShowConfigModalError}"
                         (blur)="validateProductConfigurationForm()" />
                </div>
                <div class="form-group">
                  <label class="lblCls">
                    {{productConfigurationDialog?.imageUrlLbl}}<!--<span class="requiredField">*</span>-->
                  </label>
                  <app-upload [multiple]="false" (fileSelect)="configurationImageSelected($event)" [uploadFolderPath]="'TempDocs\\ProductImages'"
                              (uploadSuccess)="configurationImageUploadSuccess($event)" [fileRestrictions]="fileRestrictions"></app-upload>

                  <!--<label class="lblCls">
                    {{fileTestReportPath}}
                  </label>-->
                </div>
                <div class="form-group">

                  <img [src]="imageConfigSrc" *ngIf="imageConfigSrc" style="height: 120px; width:300px">
                  <!--<label class="lblCls">
                    {{imageConfigSrc}}
                  </label>-->
                </div>

                <div class="form-group">
                  <label class="lblCls">
                    {{productConfigurationDialog?.isActiveLbl}}
                  </label>
                  <kendo-switch name="isActive"
                                [(ngModel)]="configModal_1.isActive" [onLabel]="'Yes'" [offLabel]="'No'"
                                class="activeSwitchCls">
                  </kendo-switch>
                </div>
                <div class="form-group">
                  <label class="lblCls">
                    {{productConfigurationDialog?.productLbl}}<span class="requiredField">*</span>
                  </label>
                  <kendo-dropdownlist class="kendoInput" name="product"
                                      [(ngModel)]="configModal_1.selectedTemplate"
                                      [data]="configModal_1.productTemplateList"
                                      textField="productCode" valueField="id"
                                      [filterable]="true" [disabled]="disableProductSelect"
                                      (filterChange)="configModalTemplateFilter($event)"
                                      [ngClass]="{'borderRed':productConfigurationDialog?.isEmptyTemplate && shouldShowConfigModalError}"
                                      (blur)="validateProductConfigurationForm()">
                  </kendo-dropdownlist>
                </div>
              </div>

            </div>

            <div class="dialog-btn-section">
              <div class="row">
                <div class="col-sm-12 float-left">
                  <app-info *ngIf="infoMessage" [infoMessage]="infoMessage"></app-info>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 btn-align-center">
                  <div class="btn-group" role="group">
                    <button kendoButton [disabled]="productConfigurationDialog?.saveInProcess" class=" m-3 btn k-button dialogBtnSize"
                            (click)="productConfigurationDialog.opened=false">
                      Close
                    </button> &nbsp;&nbsp;
                    <button kendoButton [disabled]="productConfigurationDialog?.saveInProcess" class=" m-3 btn btn-success dialogBtnSize"
                            (click)="saveProductConfiguration()">
                      Save<kendo-loader *ngIf="productConfigurationDialog?.saveInProcess" style="color:blue"></kendo-loader>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </kendo-dialog>
      </section>
    </ng-template>
  </kendo-tabstrip-tab>
  <!--<kendo-tabstrip-tab title="Template">
    <ng-template kendoTabContent>
      <kendo-grid [data]="productMappingGridView"
                  [height]="470"
                  [sortable]="true"
                  [navigable]="true"
                  [filterable]="true"
                  [groupable]="false"
                  [reorderable]="true"
                  [resizable]="false"
                  [sort]="productMappingGridstate.sort"
                  (sortChange)="productMappingGridSortChange($event)"
                  [pageable]="{ buttonCount: 5, info: true }"
                  [pageSize]="productMappingGridstate.take"
                  [skip]="productMappingGridstate.skip"
                  [columnMenu]="false"
                  (pageChange)="productMappingGridPageChange($event)"
                  (dataStateChange)="productMappingDataStateChange($event)"
                  [filter]="productMappingGridstate.filter"
                  [loading]="productMappingLoading">

        <kendo-grid-column field="categoryImageUrl" title="{{productMappingLbl.categoryImage}}" [columnMenu]="false"
                           [filterable]="false" [editable]="false">
          <ng-template kendoGridCellTemplate let-dataItem>

            <img src="{{dataItem.categoryImageUrl}}" style="height:100px;width:150px;" />

          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="categoryName" title="{{productMappingLbl.categoryName}}" [columnMenu]="false"
                           [filterable]="true" [editable]="false">
          <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="subCategoryImageUrl" title="{{productMappingLbl.subCategoryImage}}" [columnMenu]="false"
                           [filterable]="false" [editable]="false">
          <ng-template kendoGridCellTemplate let-dataItem>

            <img src="{{dataItem.subCategoryImageUrl}}" style="height:100px;width:150px;" />

          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="subCategoryName" title="{{productMappingLbl.subCategoryName}}" [columnMenu]="false"
                           [filterable]="true" [editable]="false">
          <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="configImageUrl" title="{{productMappingLbl.configImage}}" [columnMenu]="false"
                           [filterable]="false" [editable]="false">
          <ng-template kendoGridCellTemplate let-dataItem>

            <img src="{{dataItem.configImageUrl}}" style="height:100px;width:150px;" />

          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="configName" title="{{productMappingLbl.configName}}" [columnMenu]="false"
                           [filterable]="true" [editable]="false">
          <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="templateName" title="{{productMappingLbl.templateName}}" [columnMenu]="false"
                           [filterable]="true" [editable]="false">
          <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-command-column title="{{productMappingLbl.isActive}}" [width]="135" field="isActive">
      <ng-template kendoGridCellTemplate let-dataItem>
        <kendo-switch (click)="switchChange(dataItem)" [(ngModel)]="dataItem.isActive" [onLabel]="'Yes'"
                      [offLabel]="'No'">
        </kendo-switch>
      </ng-template>
    </kendo-grid-command-column>

        <kendo-grid-command-column title="{{productMappingLbl.action}}" [width]="135" field="">
          <ng-template kendoGridCellTemplate let-dataItem>
            <button kendoButton class="m-2 clearKendoButton btn btn-success btnSizeCls"
                    (click)="editproductTemplate(dataItem)">
              <span class=" k-icon k-i-edit k-i-pencil"></span>
            </button>
            <br>

          </ng-template>
        </kendo-grid-command-column>

        <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
          <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
          <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
          <kendo-pager-info></kendo-pager-info>
          <kendo-pager-next-buttons></kendo-pager-next-buttons>
          <kendo-pager-page-sizes [pageSizes]="[50,75,100]"></kendo-pager-page-sizes>
        </ng-template>
      </kendo-grid>




      <div class="col-sm-12 center">
        <button (click)="addProductTemplate()" [icon]="'plus'" class="m-3 btn btn-success" kendoButton>
          Add Product Template
        </button>
      </div>

      <section class="dialogSection">
        <kendo-dialog title="{{productTemplateDialog?.title}}" *ngIf="productTemplateDialog?.opened" (close)="productTemplateDialog.opened=false">
          <form style="max-height: 400px" autocomplete="off">
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group">
                  <label class="lblCls">
                    {{productTemplateDialog?.productCategoryLbl}}<span class="requiredField">*</span>
                  </label>
                  <kendo-dropdownlist class="kendoInput" name="productCategory"
                                      [(ngModel)]="templateModel.productCategory" [data]="productCategory"
                                      textField="name" valueField="id"
                                      (selectionChange)="productTemplateProductCategorySelectionChange($event)"
                                      [ngClass]="{'borderRed':productTemplateDialog?.isEmptyProductCategory && productTemplateDialog?.isSubmitted}"
                                      (blur)="validateProductTemplateForm()">
                  </kendo-dropdownlist>
                </div>
                <div class="form-group">
                  <label class="lblCls">
                    {{productTemplateDialog?.productSubCategoryLbl}}<span class="requiredField">*</span>
                  </label>
                  <kendo-dropdownlist class="kendoInput" name="productSubCategory" [data]="productSubCategoryByCategoryId"
                                      textField="name" valueField="id"
                                      [(ngModel)]="templateModel.productSubCategory"
                                      (selectionChange)="productTemplateProductProductSubCategorySelectionChange($event)"
                                      [ngClass]="{'borderRed':productTemplateDialog?.isEmptyProductSubCategory && productTemplateDialog?.isSubmitted}"
                                      (blur)="validateProductTemplateForm()">
                  </kendo-dropdownlist>
                </div>
                <div class="form-group">
                  <label class="lblCls">
                    {{productTemplateDialog?.productConfigurationLbl}}<span class="requiredField">*</span>
                  </label>
                  <kendo-dropdownlist class="kendoInput" name="productConfiguration" [data]="productConfigurationByProductSubCategory"
                                      textField="name" valueField="id"
                                      [(ngModel)]="templateModel.productConfiguration"
                                      [ngClass]="{'borderRed':productTemplateDialog?.isEmptyProductConfiguration && productTemplateDialog?.isSubmitted}"
                                      (blur)="validateProductTemplateForm()">
                  </kendo-dropdownlist>
                </div>
                <div class="form-group">
                  <label class="lblCls">
                    {{productTemplateDialog?.nameLbl}}<span class="requiredField">*</span>
                  </label>
                  <input type="text" kendoTextBox class="kendoInput" name="name" [(ngModel)]="templateModel.name"
                         [ngClass]="{'borderRed':productTemplateDialog?.isEmptyName && productTemplateDialog?.isSubmitted}"
                         (blur)="validateProductTemplateForm()" />
                </div>
                <div class="form-group">
                  <label class="lblCls">
                    {{productTemplateDialog?.imageUrlLbl}}<span class="requiredField">*</span>
                  </label>
                  <input type="file" class="k-button btn kendoInput" name="imageUrl"
                         (change)="handleFileInputProductTemplate($event.target.files)" />

                  <label class="lblCls">
                {{fileTestReportPath}}
              </label>
                </div>
                <div class="form-group">
                  <label class="lblCls">
                    {{productTemplateDialog?.isActiveLbl}}
                  </label>
                  <kendo-switch name="isActive" [(ngModel)]="templateModel.isActive" [onLabel]="'Yes'" [offLabel]="'No'"
                                class="activeSwitchCls">
                  </kendo-switch>
                </div>
              </div>

            </div>

            <div class="dialog-btn-section">
              <div class="row">
                <div class="col-sm-12 float-left">
                  <app-info *ngIf="infoMessage" [infoMessage]="infoMessage"></app-info>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 btn-align-center">
                  <div class="btn-group" role="group">
                    <button kendoButton [disabled]="productTemplateDialog?.saveInProcess" class=" m-3 btn k-button dialogBtnSize"
                            (click)="productTemplateDialog.opened=false">
                      Close
                    </button> &nbsp;&nbsp;
                    <button kendoButton [disabled]="productTemplateDialog?.saveInProcess" class=" m-3 btn btn-success dialogBtnSize"
                            (click)="saveProductTemplate()">
                      Save<kendo-loader *ngIf="productTemplateDialog?.saveInProcess" style="color:blue"></kendo-loader>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </kendo-dialog>
      </section>

    </ng-template>

  </kendo-tabstrip-tab>-->
</kendo-tabstrip>
<kendo-dialog title="Delete" *ngIf="gridItemToRemove" (close)="confirmRemove(false)">
  <p style="margin: 30px; text-align: center;">
    Are you sure you want to delete this row?
  </p>
  <kendo-dialog-actions>
    <button class='k-button' (click)="confirmRemove(false)">
      No
    </button>
    <button class='k-button k-primary' (click)="confirmRemove(true)" primary="true">
      Yes
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
